// src/store/useLeaveManagementStore.js
import { create } from "zustand";
import axios from "axios";

export const useLeaveManagementStore = create((set, get) => ({
  attendanceData: [],
  loading: false,
  error: null,
  lastParams: null,
  refreshing: false, // NEW: Track refresh state
  pendingRefresh: null, // NEW: Track pending refresh timeout

  setAttendanceData: (newData) => {
    set((state) => ({
      attendanceData:
        typeof newData === "function" ? newData(state.attendanceData) : newData,
    }));
  },

  getEmployeeLeaveData: async (Start, End, navigate, selectedCompany) => {
    set({ lastParams: { Start, End, navigate } });
    set({ loading: true, error: null });

    try {
      const accessToken = localStorage.getItem("accessToken");
      const permissions = JSON.parse(localStorage.getItem("userPermissions"));
      // const selectedCompany = localStorage.getItem("selectedCompany");

      let apiUrl = "";
      const hasViewAllLeaveHistory = permissions.some(
        (permission) => permission.name === "view_all_leave_history"
      );
      const hasViewAllManagedLeaveHistory = permissions.some(
        (permission) => permission.name === "view_managed_leave_history"
      );

      if (hasViewAllManagedLeaveHistory) {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/leaveHistoryForManagers?from=${Start}&to=${End}`;
      } else if (hasViewAllLeaveHistory) {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/companyWiseLeaveHistory?from=${Start}&to=${End}&company=${selectedCompany}`;
      } else {
        alert("User does not have required permissions.");
        navigate("/dashboard");
        set({ loading: false });
        return;
      }

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const dataObject = response.data?.data || {};
      const dataArray = Object.values(dataObject);

      set({
        attendanceData: dataArray,
        loading: false,
        refreshing: false, // NEW
      });
      
      return dataArray; // NEW: Return the data
    } catch (error) {
      console.error(error);
      set({
        error: error.response?.data?.message || "Failed to fetch leave data",
        loading: false,
        refreshing: false, // NEW
      });
      throw error; // NEW: Propagate error
    }
  },

  // NEW: Debounced refresh to prevent race conditions
  refreshLeaveData: async () => {
    const state = get();
    
    // Clear any pending refresh
    if (state.pendingRefresh) {
      clearTimeout(state.pendingRefresh);
    }

    // If already refreshing, queue another refresh
    if (state.refreshing) {
      const timeoutId = setTimeout(() => {
        get().refreshLeaveData();
      }, 500);
      
      set({ pendingRefresh: timeoutId });
      return;
    }

    const { lastParams } = state;

    if (!lastParams) {
      console.warn("Cannot refresh: no previous parameters found");
      return;
    }

    set({ refreshing: true });

    try {
      await get().getEmployeeLeaveData(
        lastParams.Start,
        lastParams.End,
        lastParams.navigate
      );
    } catch (error) {
      console.error("Refresh failed:", error);
      set({ refreshing: false });
    }
  },

  resetLeaveData: () => {
    const state = get();
    if (state.pendingRefresh) {
      clearTimeout(state.pendingRefresh);
    }
    set({ 
      attendanceData: [], 
      error: null, 
      loading: false, 
      lastParams: null,
      refreshing: false,
      pendingRefresh: null
    });
  },
}));